
import { all } from 'redux-saga/effects';

import serverApi from '../common/client/serverApi';
import {
    watchChangeView,
    watchChangeLayerVisibility
} from '../common/client/sagas/map';

import {
    watchReadFile
} from './project';

import history from '../history';

export default function* rootSagas() {
    // eslint-disable-next-line
    const options = {
        history: history,
        serverApi: serverApi
    };

    yield all([
        watchChangeView(options),
        watchChangeLayerVisibility(options),
        watchReadFile(options)
    ]);
}
